import { render, staticRenderFns } from "./ServiceSubheader.vue?vue&type=template&id=9f22026e&scoped=true&lang=html&"
import script from "./ServiceSubheader.vue?vue&type=script&lang=js&"
export * from "./ServiceSubheader.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSubheader.vue?vue&type=style&index=0&id=9f22026e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f22026e",
  null
  
)

export default component.exports